<template>
    <b-row style="position:fixed;top:0;bottom:0;right:0;left:0;overflow:auto;" md="12">
        <b-col v-if="!hideCarousel" md="5" class="carousel-side d-flex justify-content-center align-items-center" style="background-color:#4129A8;">
                <carousel></carousel>
        </b-col>
        <b-col :md="hideCarousel ? 12 : 7" style="background-color:#fff;" class="form-side d-flex">
            <b-card 
            :img-src="showLogo ? logoImg : ''"
            img-alt="Image"
            img-top
            style="width:25%;min-width:30rem;margin: auto;border:none;color:#022B49;"
            @keyup.enter="login(email, pass, captchaInput)"
            >
                <b-row style="position: relative">
                    <b-col>
                        <b-alert :show="forgotPasswordActivationInfo"
                                dismissible
                                @dismissed="forgotPasswordActivationInfo = 0"
                                @dismiss-count-down="countDownChanged(forgotPasswordActivationInfo)"
                                class="alert-info-cl"
                                style="width: 100%; position: relative; right: 0; left: 0; margin: auto; margin-top: 10% z-index:3;color:#2D8B61">
                                <span style="font-size:1em;">{{ $t('forgot-password-info') }}</span>
                        </b-alert>
                        <b-alert :show="showInvalidUserAlert"
                                dismissible
                                @dismissed="showInvalidUserAlert = 0"
                                @dismiss-count-down="countDownChanged(showInvalidUserAlert)"
                                variant="danger"
                                class="alert-danger-cl"
                                style="width: 100%; position: relative; right: 0; left: 0; margin: auto; margin-top: 10% z-index:3;">
                                <span style="font-size:1em;">{{ $t('alert') }}</span>
                                <span style="font-size:1em;">{{ $t('tryAgain') }}</span>
                        </b-alert>
                        <b-alert :show="showInviteCanceledAlert"
                                dismissible
                                @dismissed="showInviteCanceledAlert = 0"
                                @dismiss-count-down="countDownChanged(showInviteCanceledAlert)"
                                variant="danger"
                                class="alert-danger-cl"
                                style="width: 100%; position: relative; right: 0; left: 0; margin: auto; margin-top: 10% z-index:3;">
                                <span style="font-size:1em;">{{ $t('inviteCanceled') }}</span>
                        </b-alert>
                    </b-col>
                </b-row>
                <b-row class="m-3" style="font-weight: bold; margin-bottom:10px; font-size: 1.75em;">
                    <b-col>
                        <span style="text-align: center;">{{$t('login')}}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="mb-3">
                        <b-input-group>
                            <b-input-group-prepend is-text>
                                <img src="../assets/icon/mail_icon.svg"/>
                            </b-input-group-prepend>
                            <b-form-input v-model="email" :placeholder="$t('emailPlaceholder')" type="text" class="input-field" :class="['input-field', {'is-invalid': emailError}]" required/>
                        </b-input-group>
                        <span v-show="emailError" class="validation-error">{{$t('emptyEmail')}}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="mb-3">
                        <b-input-group>
                            <b-input-group-prepend is-text>
                                <img src="../assets/icon/password_icon.svg"/>
                            </b-input-group-prepend>
                            <b-form-input v-model="pass" :placeholder="$t('passwordPlaceholder')" type="password" id="password" :class="['input-field', {'is-invalid': passwordError}]" required/>
                            <b-input-group-append is-text>
                                <span v-if="showPassword" @click="switchPasswordVisibility('password')" key="password-visible">
                                    <!--<i class="fas fa-eye" style="filter: invert(74%) sepia(0%) saturate(1000%) hue-rotate(252deg) brightness(.8) contrast(30%) !important;cursor:pointer;"></i>-->
                                    <img src="../assets/icon/showPassword_icon.svg" key="showPass"><img>
                                </span>
                                <span v-else @click="switchPasswordVisibility('password')" key="password-invisible">
                                    <!--<i class="fas fa-eye-slash" style="filter: invert(74%) sepia(0%) saturate(1000%) hue-rotate(252deg) brightness(.8) contrast(30%) !important;cursor:pointer;"></i>-->
                                    <img src="../assets/icon/hidePassword_icon.svg" key="hidePass"><img>
                                </span>
                            </b-input-group-append>
                        </b-input-group>
                        <span v-show="passwordError" class="validation-error">{{$t('emptyPassword')}}</span>
                    </b-col>
                </b-row>
                <b-row v-show="captchaRequired" align-h="center">
                    <b-col class="mb-3" md="auto">
                        <b-row>
                            <b-col>
                                <b-img style="margin-bottom:10px" center :src="captchaImg" width="220px;"> </b-img>
                            </b-col>
                            <b-col class="button-column">
                                <b-button v-b-tooltip.hover class="mt-5" style="border-radius: 8px;" variant="primary" size="sm" @click="getCaptcha()"><i class="fas fa-sync-alt"></i></b-button>                                   
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-form-input v-model="captchaInput" style="width:100%;" :placeholder="$t('inputPlaceholderCaptcha')" type="text" id="captcha" :class="['input-field', {'is-invalid': captchaError}]" :required="captchaRequired"/>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row> 
                    <b-col class="mt-3">
                        <b-overlay
                            :show="isLoginButtonDisabled"
                            rounded
                            opacity="0.6"
                            spinner-small
                            spinner-variant="primary"
                            class="d-inline-block"
                        >
                            <b-button @click="login(email, pass, captchaInput)" class="px-5 light-green" :disabled="isLoginButtonDisabled">
                                {{ $t('loginButton') }} 
                            </b-button>
                        </b-overlay>
                    </b-col>
                </b-row>
                <b-row> 
                    <b-col class="mt-2">
                        <span><router-link :to="{name: 'forgot-password'}" class="link">{{$t('forgotPassword')}}</router-link></span>
                    </b-col>
                </b-row>
                
            </b-card>
        </b-col>

    </b-row>

</template>

<script>
import Carousel from '../components/Carousel.vue';
import _ from 'lodash';
export default {
    components: { Carousel },
    name: 'login',
    data() {
        return {
            email: null,
            pass: null,
            captchaInput: null,
            captchaImg: null,
            captchaId: null,
            captchaRequired: false,
            captchaError: false,
            showPassword: false,
            err: null,
            dismissSecs: 10,
            passwordError: false,
            emailError: false,
            title: 'Carbon Intelligence',
            logoImg: '../../static/background.jpg',
            showLogo: false,
            showInvalidUserAlert: 0,
            forgotPasswordActivationInfo: 0,            
            showInviteCanceledAlert: 0,
            hideCarousel: false,
            isLoginButtonDisabled: false
        };
    },
    methods: {
        switchPasswordVisibility(id){
            this.showPassword=!this.showPassword;
            const passwordField = document.querySelector('#'+id);
            if (passwordField.getAttribute('type') === 'password') passwordField.setAttribute('type', 'text')
            else passwordField.setAttribute('type', 'password')
        },
        isValid(){
            let captchaValid = this.captchaRequired ? this.captchaInput : true;
            this.passwordError = !this.pass;
            this.emailError = !this.email;
            return !(this.passwordError || this.emailError) && captchaValid;
        },
        login(email, pass, captchaInput) {
            if(this.isValid()){
                captchaInput = this.captchaRequired ? captchaInput : 'a';
                this.isLoginButtonDisabled = true;
                this.$Progress.start();
                return this.axios
                    .post('/login', {
                        email,
                        password: pass,
                        captchaToken: captchaInput,
                        captchaId: this.captchaId
                    })
                    .then(response => {
                        if (response.data.token) {
                            localStorage.setItem('token', response.data.token);
                            document.cookie = `Authorization=Bearer ${response.data.token}`;
                            this.$store.state.token = `Bearer ${response.data.token}`;
                            this.axios.defaults.headers.Authorization = response.data.token
                                ? `Bearer ${response.data.token}`
                                : 'Bearer ';
                            this.$store.dispatch('init').then(() => {
                                this.$router.push({name: 'dashboard'});
                                this.$root.$i18n.locale = this.$store.state.locale;
                            });
                        } else {
                            this.isLoginButtonDisabled = false;
                        }
                        this.$Progress.finish();
                        
                        return true;
                    })
                    .catch(err => {
                        this.showInvalidUserAlert = this.dismissSecs;
                        this.err = err;
                        this.getCaptcha();
                        this.isLoginButtonDisabled = false;
                        this.$Progress.finish();
                    });
            }
        },
        getCaptcha() {
            return this.axios
                .post('/captcha')
                .then(response => {
                    (this.captchaId = response.data.id), (this.captchaImg = response.data.imgSrc) (this.captchaRequired = response.data.required);
                })
                .catch(err => {
                    this.err = err;
                    this.$Progress.finish();
                });
        },

        countDownChanged(dismissCountDown) {
            return dismissCountDown = dismissCountDown-1;
        },

        init(){
            this.forgotPasswordActivationInfo = (_.get(this.route.query, 'passwordResetInfo') != undefined && _.get(this.route.query, 'passwordResetInfo')) ? this.dismissSecs : 0;
            this.showInviteCanceledAlert = (_.get(this.route.query, 'inviteCanceled') != undefined && _.get(this.route.query, 'inviteCanceled')) ? this.dismissSecs : 0;
        },
        onResize(){
            this.windowHeight = window.innerHeight;
            this.windowWidth = window.innerWidth;
            this.hideCarousel = this.windowWidth < 1080;
        }
    },
    created(){
        this.onResize();
        this.init();
    },
    beforeMount() {
        this.getCaptcha();
    },
    mounted() {
        window.addEventListener('resize', this.onResize);
        if (window.location.href.match('garanti')) {
            this.logoImg = '../../static/garanti.png';
            this.title = 'titleGaranti';
            this.showLogo = true;
            this.hideCarousel = true;
        }
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.onResize);
    }
};
</script>

<style lang="scss" scoped>
.carousel-side, .form-side {
    height: 100vh;
    width: 100%;
}
.input-field {
    background-color: #EFEDF5;
    color: #022B49;
    font-size: 1em;
}
.input-field::placeholder {
    color : #A0A0A0;
}
.input-field:focus {
    outline: none !important;
    border:1px solid #8276c3;
    box-shadow: none;
}

.validation-error {
    color: #F14079;
    float: left;
    font-size: .7em;
}

a {
    color: #D118A8;
    text-decoration: underline;
    font-weight: bold;
}

.alert-info-cl{
    background-color:#DAF8EB !important;
}
.alert-danger-cl{
    color: #F14079; 
    background-color:rbga(241,64,121,0.2) !important;
}

.input-group-prepend .input-group-text {
  background-color: #EFEDF5;
}
.input-group-append .input-group-text {
  background-color: #EFEDF5;
}

.input-group-prepend > .form-input   {
  border-left:0 !important;
}

.light-green {
    background-color: #49DC9B;
    font-weight: bold;
    border: none;
}
.captcha-input {
    position: relative;
    width: 180px;
    padding: 5px;
    font-size: 16px;
    margin: auto;
}

@media only screen and (max-width:780px) {
    .carousel-side, .form-side {
        height: 100vh;
        width: 100%
    }
    .placeholder span {
        color: #A0A0A0;
        font-size: .6em;
    }
}

</style>

<i18n>
    {
        "tr": {
            "title":"Reengen Sürdürülebilirlik Platformu",
            "titleGaranti":"Çevre Yönetim Sistemi Yazılımı (ÇYS)",
            "alert": "Kullanıcı adı veya şifre hatalı",
            "tryAgain": "Lütfen tekrar deneyin.",
            "inviteCanceled": "Bu davet artık geçerli değil",
            "inputPlaceholderUsername" : "Kullanıcı Adı",
            "inputPlaceholderPassword" : "Şifre",
            "inputPlaceholderCaptcha" : "Resimdeki metni girin",
            "loginButton" : "Giriş Yap",
            "login": "Giriş Yap",
            "forgotPassword": "Şifremi Unuttum",
            "emptyPassword": "Lütfen şifre girin",
            "emptyEmail": "Lütfen e-posta adresinizi girin",
            "forgot-password-info": "Size şifre sıfırlama talimatları gönderdik. Lütfen emailinizi kontrol edin.",
            "emailPlaceholder": "E-posta",
            "passwordPlaceholder": "Şifre"

        },
        "en": {
            "title":"Reengen Sustainability Platform",
            "titleGaranti":"Environmental Management System Software (EMS)",
            "alert": "Your email or password is incorrect.",
            "tryAgain": "Please try again.",
            "inviteCanceled": "This invitation no longer available",
            "inputPlaceholderUsername" : "Username",
            "inputPlaceholderPassword" : "Password",
            "inputPlaceholderCaptcha" : "Enter image text",
            "loginButton" : "Login",
            "login": "Sign In",
            "forgotPassword": "Forgot Password?",
            "emptyPassword": "Please enter your password",
            "emptyEmail": "Please enter your email",
            "forgot-password-info": "We sent password instructions to your email. Please check your email.",
            "emailPlaceholder": "Email",
            "passwordPlaceholder": "Password"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Login.vue